<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
    :before-close="closeDialog"
    v-el-drag-dialog
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
     top="8vh"
     width="70%"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :icon="'carRealData'"
      :title="$t('车辆当日详情')"
      @close="closeDialog"
    />
   <el-table
      ref="table"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
 
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <div v-if="item.prop==='licensePlate'">
            <vue-licenseplate
              :licensepalte="scope.row[item.prop]"
              :area="scope.row['areaName']"
            />
          </div>
          <div v-else-if="item.prop==='behaviortype'">
           {{scope.row[item.prop]==="N1"?'行程数据'
            :scope.row[item.prop]==="N2"? '急加速'
            :scope.row[item.prop]==="N3"?'急减速'
            :scope.row[item.prop]==="N4"?'急转变'
            :scope.row[item.prop]==="E1"?'异常移动'
            :scope.row[item.prop]==="E2"?'防拆报警'
            :''
           }}
          </div>
          <div v-else-if="item.prop==='begintime'">
            <span style="color: green">
              <span>{{ $t('public.startTime') }}：{{ scope.row[item.prop] }}</span><br>
              <el-popover
                v-if="scope.row['tripStartAddress']"
                placement="top-start"
                width="230"
                trigger="hover"
                :visible-arrow="false"
                :content="$t('book.startingPlace')+'：'+scope.row['tripStartAddress']"
              >
                <span slot="reference">{{ $t('book.startingPlace') }}：{{ scope.row['tripStartAddress'] }}</span>
              </el-popover>
              <span v-else>{{ $t('book.startingPlace') }}：{{ scope.row['sLongitude'] }} , {{ scope.row['sLatitude'] }}</span>
            </span>
          </div>
          <div v-else-if="item.prop==='endtime'">
            <span style="color: red">
              <span>{{ $t('public.endTime') }}：{{ scope.row[item.prop] }}</span><br>
              <el-popover
                v-if="scope.row['tripEndAddress']"
                placement="top-start"
                width="230"
                trigger="hover"
                :visible-arrow="false"
                :content="$t('book.endAddress')+'：'+scope.row['tripEndAddress']"
              >
                <span slot="reference">{{ $t('book.endAddress') }}：{{ scope.row['tripEndAddress'] }}</span>
              </el-popover>
             
              <span v-else>{{ $t('book.endAddress') }}：{{ scope.row['eLongitude'] }},{{ scope.row['eLatitude'] }}</span>
            </span>
          </div>
    
          <div v-else-if="item.prop==='mileage' || item.prop==='drivingtime' || item.prop==='fuelConsumption' || item.prop==='tripTotalCarbon'">
            <span>
              {{scope.row[item.prop] | fixedText(item.prop) }}
            </span>
          </div>
     
          <div v-else>
            <span>{{ scope.row[item.prop] || scope.row[item.prop] === 0 ? scope.row[item.prop] : '/' }}</span>
          </div>
        </template>
      </el-table-column>
 
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
import { getTripDetails } from '@/api/vehicletravel/mileageStatistics'
export default {
  name: 'realDialog',
  filters: {
    fixedText(val) {
      return (val/1).toFixed(1) || '/'
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mixins: [partialForm,pagingMixin,otherHeight,tableStyle,getPageButton],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },

    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
        formInfo: {},
        list:[],
        tableHeight: 0,
        total: 0,
        listLoading: false,
        tableList: [
        { value: this.$t('public.licensePlate'), width: '150px', prop: 'licensePlate', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('carMonitor.vehicle.areaName'), width: '150px', prop: 'areaName', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('public.terminal'), width: '150px', prop: 'terminalcode', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('public.obdCode'), width: '150px', prop: 'barcode', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('book.startOfJourney'), width: this.$t('book.labelWidth.startOfJourney'), prop: 'begintime', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('book.endOfTrip'), width: this.$t('book.labelWidth.startOfJourney'), prop: 'endtime', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('book.vehicleUseApprovalScore'), width: '180px', prop: 'score', position: 'center', checked: true },
        { value: this.$t('book.aperationTiemLenthen'), width: '160px', prop: 'drivingtime', position: 'center',sortable: 'custom', checked: true },
        { value: this.$t('book.aperationMileage'), width: '160px', prop: 'mileage', position: 'center',sortable: 'custom', checked: true },
        { value: this.$t('book.oil'), width: '150px', prop: 'fuelConsumption', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('book.rapidAcceleration'), width: '150px', prop: 'rapidCcceleration', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('book.emergencyBrake'), width: '150px', prop: 'rapidCeceleration', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('public.createTime'), prop: 'createtime', sortable: 'custom', position: 'center', width: '200px', checked: true },
        { value: this.$t('行为类型'), width: '150px', prop: 'behaviortype', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('carMonitor.trip.startLngLat'), prop: 'sLongitude', sortable: 'custom', position: 'center', width: '220px', checked: true },
        { value: this.$t('carMonitor.trip.endLngLat'), prop: 'eLongitude', sortable: 'custom', position: 'center', width: '220px', checked: true },
        { value: this.$t('开始纬度'), width: '150px', prop: 'sLatitude', sortable: 'custom', position: 'center', checked: true },
        { value: this.$t('结束纬度'), width: '150px', prop: 'eLatitude', sortable: 'custom', position: 'center', checked: true },
      ],

    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.data }
        this.listLoad()
      }
    }
  },
  created() {
  },
  methods: {
    // 加载数据
    listLoad(){
         if (!this.visibles) {
        return
      }
      this.listLoading = true
      let params = {
        carId : this.formInfo.carId,
        date : this.formInfo.day
      }
      console.log(params)
  
      getTripDetails(params).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data
        }
        this.listLoading = false
      })
    },

    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    }
  }
}
</script>

<style scoped>

</style>
